import React, { Component } from 'react';
import { Grid, Col, Row, Container } from 'react-bootstrap';


class Skills extends Component {
    render() {
        return (
            <Grid className="skills-body">
                <Row className="skills-row">
                    <p className="skill-type">A few languages that I speak...</p>
                    <Col lg={12} className="skills-columns">
                    <img className='skills-logo' alt="html-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain-wordmark.svg" />
                    <img className="skills-logo" alt="css-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" />
                    <img className="skills-logo" alt="js-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg" />
                    </Col>
                </Row>
                <Row>
                    <Col className="skills-columns" lg={12}></Col>
                </Row>
                <Row className="skills-row">
                    <p className="skill-type">...A couple tools that help get the job done</p>
                    <Col lg={12} className="skills-columns">
                    <img className="skills-logo" alt="react-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" />
                    <img className="skills-logo" alt="adobe-xd-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/xd/xd-line.svg" />
                    <img className="skills-logo" alt="illustrator-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/illustrator/illustrator-plain.svg" />
                   </Col>
                   <Col lg={12} className="skills-columns">
                    {/* <img className="skills-logo" alt="sass-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg" /> */}
                    <img className="skills-logo" alt="slack-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/slack/slack-original.svg" />
                    <img className="skills-logo" alt="vscode-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original-wordmark.svg" />
                    <img className="skills-logo" alt="monday-logo" src="https://www.vectorlogo.zone/logos/monday/monday-icon.svg"/>
                    </Col>
                    <Col lg={12} className="skills-columns" >
                    <img className="skills-logo" alt="node-js-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-plain-wordmark.svg"/>
                    <img className="skills-logo" alt="npm-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg" />
                    <img className="skills-logo" alt="bootstrap-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg" />
                    </Col>
                    <Col lg={12} className="skills-columns" >
                    <img className="skills-logo" alt="jquery-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-plain-wordmark.svg" />
                    <img className="skills-logo" alt="heroku-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain-wordmark.svg" />
                    <img className="skills-logo" alt="git-logo" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain-wordmark.svg" />
                    </Col>
                </Row>
            </Grid>
        );
       
    }
    
}

export default Skills;
